import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Adjuster } from '../../../models/adjuster';
import { ClaimService } from '../../../services/claim.service';
import { AutoComplete, AutoCompleteCompleteEvent, AutoCompleteModule, AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-adjuster-search',
  standalone: true,
  imports: [AutoCompleteModule, FormsModule, DatePipe, CardModule, ButtonModule],
  templateUrl: './adjuster-search.component.html',
  styleUrl: './adjuster-search.component.scss'
})
export class AdjusterSearchComponent 
{
  @Input() placeholder: string = "Search";
  @Output() adjusterSelected = new EventEmitter<Adjuster>();
  @ViewChild('adjusterSearchComponent') adjusterSearchField?: AutoComplete;


  constructor
  (
    public _claimService: ClaimService
  )
  {
    
  }

  

  adjusterSuggestions: Adjuster[] = [];
  selectedAdjuster? : Adjuster;


  adjusterSearch(event:AutoCompleteCompleteEvent )
  {
    //Update the suggestions to our query results
    this._claimService.searchAdjusters(event.query)
    .then
    (
      adjusters => 
        {
          this.adjusterSuggestions = adjusters;
        }
    )
  }

  selectAdjuster(event: AutoCompleteSelectEvent)
  {
    this.adjusterSelected.emit(this.selectedAdjuster);
  }
  
  searchFor(input: string)
  {
    if(this.adjusterSearchField)
    {
      this.adjusterSearchField.writeValue(input);
      this.adjusterSearchField.search(null,input,null);
    }
  }
}
